import { DashboardCard } from "@dashboard/components/Card";
import { OrderDetailsFragment } from "@dashboard/graphql";
import { OrderDetailsViewModel } from "@dashboard/orders-v2/order-details-view-model";
import { Text } from "@saleor/macaw-ui-next";
import { FormattedMessage } from "react-intl";

import SummaryLine from "../../../OrderSummaryCard/SummaryLine";
import { SummaryList } from "../../../OrderSummaryCard/SummaryList";
import { orderPaymentMessages } from "../../messages";
import { useStyles } from "../../styles";

interface PaymentsSummaryProps {
  order: OrderDetailsFragment;
}

export const PaymentsSummary = ({ order }: PaymentsSummaryProps) => {
  const classes = useStyles();
  const shouldDisplay = OrderDetailsViewModel.getShouldDisplayAmounts(order);
  const paymentMethod = order.metadata?.find(
    metadataItem => metadataItem.key === "paymentMethod",
  )?.value;
  const paymentDetails = order.metadata?.find(
    metadataItem => metadataItem.key === "paymentDetails",
  )?.value;

  return (
    <DashboardCard.Content>
      <SummaryList className={classes.amountGrid}>
        <SummaryLine
          text={<FormattedMessage {...orderPaymentMessages.authorized} />}
          money={order.totalAuthorized}
        />

        {shouldDisplay.authorizedPending && (
          <SummaryLine
            text={<FormattedMessage {...orderPaymentMessages.authorized} />}
            subText={<FormattedMessage {...orderPaymentMessages.pending} />}
            money={order.totalAuthorizePending}
          />
        )}

        <SummaryLine
          text={<FormattedMessage {...orderPaymentMessages.captured} />}
          money={order.totalCharged}
        />

        {shouldDisplay.chargedPending && (
          <SummaryLine
            text={<FormattedMessage {...orderPaymentMessages.captured} />}
            subText={<FormattedMessage {...orderPaymentMessages.pending} />}
            money={order.totalChargePending}
          />
        )}

        <SummaryLine
          text={<FormattedMessage {...orderPaymentMessages.cancelled} />}
          money={order.totalCanceled}
        />

        {shouldDisplay.cancelledPending && (
          <SummaryLine
            text={<FormattedMessage {...orderPaymentMessages.cancelled} />}
            subText={<FormattedMessage {...orderPaymentMessages.pending} />}
            money={order.totalCancelPending}
          />
        )}
      </SummaryList>
      {(!!paymentMethod || !!paymentDetails) && (
        <div className={classes.paymentMetadata} data-test-id="payment-metadata">
          {!!paymentMethod && (
            <Text data-test-id="payment-method">
              <FormattedMessage
                {...orderPaymentMessages.paymentMethod}
                values={{ paymentMethod }}
              />
            </Text>
          )}
          {!!paymentDetails && (
            <Text data-test-id="payment-details">
              <FormattedMessage
                {...orderPaymentMessages.paymentDetails}
                values={{ paymentDetails }}
              />
            </Text>
          )}
        </div>
      )}
    </DashboardCard.Content>
  );
};
